import React, { useState, useEffect, useRef } from "react";
import { Box, Columns, Heading, Section } from 'react-bulma-components';
import { AreaChart, Area, BarChart, Bar, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import Loading from "shared/components/loading/Loading";
import { ArrowUpCircle, Mail, UserPlus, Users, Zap } from 'react-feather';
//
import { areaChartData, barChartData } from './sample';

// styles
import styles from './Dashboard.module.scss';

const Dashboard = ()=> {
    const [isLoading, setIsLoading] = useState(true);
    const isMounted = useRef(null);

    useEffect(() => {
        isMounted.current = true;
        setIsLoading(false);
        return () => {
            // executed when unmount
            isMounted.current = false;
        }
    }, []); // empty dependency array means this effect will only run once

    return (
        <><Section>
            { /*<Heading>DASHBOARD</Heading> */ }
            <hr />
            <Columns style={{marginRight: '1rem'}}>
                <Columns.Column>
                    <Box className={ `${styles.card} ${styles.leads}` }>
                        <h3 className="is-size-7 mt-4 has-text-centered">New Leads</h3>
                        <div className="pb-4">
                            <span className={ styles.valueText }>34</span>
                        </div>
                        <Zap size={75} strokeWidth={1.5} className={ styles.icon } />
                    </Box>
                </Columns.Column>
                <Columns.Column>
                    <Box className={ `${styles.card} ${styles.users}` }>
                        <h3 className="is-size-7 mt-4 has-text-centered">New Members</h3>
                        <div className="pb-4">
                            <span className={ styles.valueText }>8</span>
                        </div>
                        <UserPlus size={75} strokeWidth={1.5} className={ styles.icon } />
                    </Box>
                </Columns.Column>
                <Columns.Column>
                    <Box className={ `${styles.card} ${styles.contacts}` }>
                        <h3 className="is-size-7 mt-4 has-text-centered has-text-white">New Contacts</h3>
                        <div className="pb-4">
                            <span className={ styles.valueText }>45</span>
                        </div>
                        <Mail size={74} strokeWidth={1.5} className={styles.icon} />
                    </Box>
                </Columns.Column>
                <Columns.Column>
                    <Box className={ `${styles.card} ${styles.outgoing}` }>
                        <h3 className="is-size-7 mt-4 has-text-centered has-text-white">Outgoing</h3>
                        <div className="pb-4">
                            <span className={ styles.valueText }>$14k</span>
                        </div>
                        <ArrowUpCircle size={75} strokeWidth={1.5} className={styles.icon} />
                    </Box>
                </Columns.Column>
            </Columns>
            <Columns className="mt-6">
                <Columns.Column>
                    <Box>
                        <h3 className="is-size-6 mt-6 has-text-centered">Card Balance</h3>
                        <div className="pb-6" style={{ height: '400px', width: '100%', fontSize: '1.1rem', color: '#7C828A'}}>
                            <ResponsiveContainer width="100%" height="100%">
                                <AreaChart
                                  width={500}
                                  height={400}
                                  data={areaChartData}
                                  margin={{
                                    top: 20,
                                    right: 30,
                                    left: 0,
                                    bottom: 0,
                                  }}
                                >
                                  <XAxis dataKey="name" />
                                  <YAxis stroke="#666666"/>
                                  <Tooltip />
                                  <Area type="monotone" dataKey="uv" stackId="1" stroke="#FFD34D" fill="#FFC000" />
                                  <Area type="monotone" dataKey="amt" stackId="1" stroke="#FFD34D" fill="#FFD34D" />
                                  <Area type="monotone" dataKey="pv" stackId="1" stroke="#FFD34D" fill="#FFECB3" />
                                </AreaChart>
                              </ResponsiveContainer>
                        </div>
                    </Box>
                </Columns.Column>

                <Columns.Column>
                    <Box>
                        <h3 className="is-size-6 mt-6 has-text-centered">Leads Stats</h3>
                        <div className="pb-6" style={{ height: '400px', width: '100%', fontSize: '1.1rem', color: '#7C828A'}}>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart
                                  width={500}
                                  height={300}
                                  data={barChartData}
                                  margin={{
                                    top: 30,
                                    right: 10,
                                    left: 10,
                                    bottom: -5,
                                  }}
                                >

                                  <XAxis dataKey="name" />
                                  <YAxis yAxisId="left" orientation="left" stroke="#003F5E" />
                                  <YAxis yAxisId="right" orientation="right" stroke="#FFC000" />
                                  <Tooltip />
                                  <Legend />
                                  <Bar yAxisId="left" dataKey="pv" barSize={10} fill="#003F5E" />
                                  <Bar yAxisId="right" dataKey="uv" barSize={10} fill="#FFC000" />
                                </BarChart>
                              </ResponsiveContainer>
                        </div>
                    </Box>
                </Columns.Column>
{ /*
                <Columns.Column size={3} style={{display: 'flex', flexDirection: 'column'}}>
                    <Box style={{flex: 1, margin: '0 2rem'}}></Box>
                    <Box style={{flex: 1, margin: '2rem 2rem 0'}}></Box>
                    <Box style={{flex: 1, margin: '2rem 2rem 0'}}></Box>
                </Columns.Column>
    */ }
            </Columns>
        </Section>
        <Loading isLoading={ isLoading }/></>
    );
}

export default Dashboard;
